module.exports = __webpack_public_path__ + "img/cafe_mobile_01.65e4c150.png";